import { Reducer } from 'redux';
import { update } from '../../helpers/immutabilityHelper'
import * as Dtos from '../../dtos/Tmd.dtos';

import {
    ACTION_TRIALGROUPITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE,
    ACTION_TRIALGROUPITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE
} from '../../actions/pages/trialGroupItemsPage';


export interface ITrialGroupItemsPageState {
    editModalOpen: boolean;
    collectionInstanceId: number;
    name: string;
    description: string;
    createVersionModalOpen: boolean;
    trialGroupItem: Dtos.TrialGroupItem
}

const initialState: ITrialGroupItemsPageState = {
    editModalOpen: false,
    collectionInstanceId: null,
    name: "",
    description: "",
    createVersionModalOpen: false,
    trialGroupItem: null
};


function setEditModalViewState(state: ITrialGroupItemsPageState, open: boolean, collectionInstanceId: number, name: string, description: string): ITrialGroupItemsPageState {
    const newState: ITrialGroupItemsPageState = update(state, {
        editModalOpen: {
            $set: open
        },
        collectionInstanceId: {
            $set: collectionInstanceId
        },
        name: {
            $set: name
        },
        description: {
            $set: description
        }
    });
    return newState;
}

function setCreateVersionModalViewState(state: ITrialGroupItemsPageState, open: boolean, trialGroupItem: Dtos.TrialGroupItem): ITrialGroupItemsPageState {
    const newState: ITrialGroupItemsPageState = update(state, {
        createVersionModalOpen: {
            $set: open
        },
        trialGroupItem: {
            $set: trialGroupItem
        }
    });
    return newState;
}

const TrialGroupItemsPageReducer: Reducer<ITrialGroupItemsPageState> = (state: ITrialGroupItemsPageState = initialState, action) => { 
    switch (action.type) {
        case ACTION_TRIALGROUPITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE:
            return setEditModalViewState(state, action.open, action.collectionInstanceId, action.name, action.description);
        case ACTION_TRIALGROUPITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE:
            return setCreateVersionModalViewState(state, action.open, action.trialGroupItem);
    }

    return state;
}

export default TrialGroupItemsPageReducer;